import React from 'react';

const LoadingScreen = ({ isVisible, subtitle }) => {
  if (!isVisible) return null;

  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100vw',
        height: '100vh',
        background:
          'linear-gradient(139deg, rgba(175, 255, 139, 1) 0%, rgba(255, 191, 130, 1) 45%, rgba(255, 124, 123, 1) 100%)',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 9999,
        fontFamily:
          '-apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
      }}
    >
      <div
        style={{
          backgroundColor: 'white',
          borderRadius: '30px',
          padding: '60px 40px',
          textAlign: 'center',
          maxWidth: '400px',
          width: '90%',
          boxShadow: '0 20px 40px rgba(0, 0, 0, 0.15)',
          animation: 'fadeInScale 0.3s ease-out',
        }}
      >
        {/* Loading Title */}
        <h1
          style={{
            fontSize: '32px',
            fontWeight: '700',
            color: '#2c2c2c',
            margin: '0 0 20px 0',
            animation: 'slideInFromTop 0.3s ease-out',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '2px',
          }}
        >
          Loading
          <span style={{ animation: 'dotBlink 1.5s infinite 0s' }}>.</span>
          <span style={{ animation: 'dotBlink 1.5s infinite 0.5s' }}>.</span>
          <span style={{ animation: 'dotBlink 1.5s infinite 1s' }}>.</span>
        </h1>

        {/* Featured Image */}
        <div
          style={{
            margin: '30px 0',
            animation: 'zoomIn 0.3s ease-out',
            position: 'relative',
          }}
        >
          <img
            src="jim2025.jpg"
            alt="Chili cookoff celebration"
            style={{
              width: '100%',
              maxWidth: '280px',
              height: 'auto',
              borderRadius: '16px',
              boxShadow: '0 8px 24px rgba(0, 0, 0, 0.12)',
            }}
          />

          {/* iOS-style Loading Spinner */}
          <div
            style={{
              position: 'absolute',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              width: '40px',
              height: '40px',
              borderRadius: '50%',
              background: 'rgba(0, 0, 0, 0.3)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <div
              style={{
                width: '20px',
                height: '20px',
                border: '2px solid transparent',
                borderTop: '2px solid white',
                borderRadius: '50%',
                animation: 'iosSpinner 1s linear infinite',
              }}
            />
          </div>
        </div>

        {/* Subtitle Message */}
        {subtitle && (
          <p
            style={{
              fontSize: '18px',
              color: '#666',
              margin: '20px 0 30px 0',
              animation: 'slideInFromBottom 0.3s ease-out',
            }}
          >
            {subtitle}
          </p>
        )}

        {/* Loading Button */}
        <div
          style={{ display: 'flex', justifyContent: 'center', width: '100%' }}
        >
          <button
            disabled
            style={{
              backgroundColor: '#f5f5f5',
              color: '#999',
              border: '1px solid #e0e0e0',
              borderRadius: '12px',
              padding: '14px 32px',
              fontSize: '16px',
              fontWeight: '500',
              cursor: 'not-allowed',
              minWidth: '150px',
              animation: 'fadeIn 0.3s ease-out',
              fontFamily: 'inherit',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '2px',
              margin: '0 auto',
            }}
          >
            Loading
            <span style={{ animation: 'dotBlink 1.5s infinite 0s' }}>.</span>
            <span style={{ animation: 'dotBlink 1.5s infinite 0.5s' }}>.</span>
            <span style={{ animation: 'dotBlink 1.5s infinite 1s' }}>.</span>
          </button>
        </div>
      </div>

      {/* CSS Animations */}
      <style>{`
        @keyframes fadeInScale {
          from {
            opacity: 0;
            transform: scale(0.9);
          }
          to {
            opacity: 1;
            transform: scale(1);
          }
        }
        
        @keyframes slideInFromTop {
          from {
            opacity: 0;
            transform: translateY(-20px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
        
        @keyframes slideInFromBottom {
          from {
            opacity: 0;
            transform: translateY(20px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
        
        @keyframes zoomIn {
          from {
            opacity: 0;
            transform: scale(0.8);
          }
          to {
            opacity: 1;
            transform: scale(1);
          }
        }
        
        @keyframes fadeIn {
          from {
            opacity: 0;
          }
          to {
            opacity: 1;
          }
        }
        
        @keyframes dotBlink {
          0%, 80%, 100% {
            opacity: 0;
          }
          40% {
            opacity: 1;
          }
        }
        
        @keyframes iosSpinner {
          0% {
            transform: rotate(0deg);
          }
          100% {
            transform: rotate(360deg);
          }
        }
      `}</style>
    </div>
  );
};

export default LoadingScreen;
